/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from "@mui/material";
import config from "../utils/config";
import { useEffect, useState } from "react";
import { styles } from "./component.styles";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import * as Proptypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { formatNumber } from "../utils";

export default function AppCurrencySelect({ currencies, cryptoCurrency, setCryptoCurrency, showExchangeRate = false, showNetwork = true, overlay = false }) {
    const [expanded, setExpanded] = useState(false);
    const [selected, setSelected] = useState(cryptoCurrency || {});
    const { t } = useTranslation();
    const getLogo = (currency) => {
        return `${config.S3_GYL_ICONS}/${currency.toLowerCase()}.svg`;
    };
    // Sync selected state with prop cryptoCurrency
    useEffect(() => {
        if (
            cryptoCurrency?.currency !== selected?.currency ||
            cryptoCurrency?.network !== selected?.network
        ) {
            setSelected(cryptoCurrency);
        }
    }, [cryptoCurrency]);

    // Update the parent state when selection changes
    useEffect(() => {
        if (selected && Object.keys(selected).length) {
            setCryptoCurrency(selected);
        }
    }, [selected]);
    return <Accordion
        expanded={expanded}
        onChange={(_, expanded) => setExpanded(expanded)}
    >
        <AccordionSummary>
            {
                <Box
                    width={"100%"}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    {!!(selected && Object.keys(selected).length) && (
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            width={"50%"}
                        >
                            <img
                                src={getLogo(selected.currency)}
                                alt="icon"
                            />
                            <Box marginLeft={2}>
                                <Typography fontSize={12}>
                                    {
                                        selected?.payoutCurrency?.currency
                                            ?.fullTitle
                                    }
                                </Typography>
                                <Typography fontSize={10}>
                                    {selected?.currency}
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                        width={'100%'}
                    >
                        {
                            !!(showExchangeRate && selected && Object.keys(selected).length) && <Box>
                                <Typography textAlign={"center"} fontSize={14} marginRight={3}>
                                    1 {selected.currency} = {formatNumber(selected?.payoutCurrency?.currency?.currentRate)} USD
                                </Typography>
                            </Box>
                        }
                        {showNetwork && !!(selected && Object.keys(selected).length) && (
                            <Box>
                                <Typography textAlign={"center"} fontSize={10}>
                                    {t("network")}
                                </Typography>
                                <Typography textAlign={"center"} fontSize={12}>
                                    {selected?.networkFullTitle?.toUpperCase() ||
                                        " --- "}
                                </Typography>
                            </Box>
                        )}

                    </Box>
                    <Box marginLeft={2}>
                        {!!expanded && <ArrowDropUp />}
                        {!expanded && <ArrowDropDown />}
                    </Box>

                </Box>
            }
        </AccordionSummary>
        <AccordionDetails sx={{
            height: overlay ? 200 : 300, overflowY: 'auto', width: overlay ? {
                xs: '83vw',
                md: '42.5vw'
            } : 'auto', position: overlay ? 'absolute' : 'unset', zIndex: 9, backgroundColor: 'rgba(4, 25, 57)'
        }}>
            <List>
                {currencies &&
                    currencies.map((val, index) => (
                        <ListItem
                            key={index}
                            onClick={() => {
                                setSelected(val);
                                setExpanded(false);
                            }}
                            style={
                                selected.id === val.id ? styles.selected : {}
                            }
                        >
                            <ListItemAvatar>
                                <Avatar>
                                    <img src={getLogo(val.currency)} alt="icon" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={val?.payoutCurrency?.currency?.fullTitle}
                                secondary={val.currency}
                            />
                            <ListItemSecondaryAction sx={{ minWidth: "100px" }}>
                                <Typography fontSize={10}>{t("network")}</Typography>
                                <Typography fontSize={12}>
                                    {val?.networkFullTitle?.toUpperCase() || " --- "}
                                </Typography>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
            </List>
        </AccordionDetails>
    </Accordion>
}

AppCurrencySelect.propTypes = {
    currencies: Proptypes.array,
    cryptoCurrency: Proptypes.object,
    setCryptoCurrency: Proptypes.func,
};
